import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h2>404 - Page Not Found</h2>
      <p>お探しのページは見つかりませんでした。</p>
    </div>
  );
};

export default NotFound;